import { render, staticRenderFns } from "./modal-list.vue?vue&type=template&id=c097b684&scoped=true&lang=pug&"
import script from "./modal-list.vue?vue&type=script&lang=ts&"
export * from "./modal-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c097b684",
  null
  
)

export default component.exports